import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams, AddressParamsModel } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import {
	RegionCitiesModel,
	TimeSlotsModel,
	AddressModel,
	AppointmentDataModel,
} from 'Pages/orders_design'

export type State = {
	items: RegionCitiesModel[]
	params: RequestParams
	slots: Map<string, TimeSlotsModel[]>
	address: ResponseCatalog<AddressModel>
	addressParams: RequestParams
	appointment_response: { value: string; id: number }
	appointment_status: { value: string; id: string }
	formError: number
	appointment_timer: number
	sentAppointmentRequest: boolean
	outOfficeReserveError: string
}

export const outOfficeInitialState: State = {
	items: [],
	params: new RequestParams(),
	slots: new Map(),
	address: new ResponseCatalog<AddressModel>(),
	addressParams: new RequestParams(),
	appointment_response: { value: null, id: null },
	appointment_status: { value: null, id: null },
	formError: null,
	appointment_timer: null,
	sentAppointmentRequest: false,
	outOfficeReserveError: null,
}

export namespace outOfficeNS {
	export type getCitiesRegions = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type setCitiesRegions = PayloadAction<RegionCitiesModel[]>
	export type setRequestParams = PayloadAction<RequestParams>
	export type getSlots = PayloadAction<{
		params?: RequestParams
	}>
	export type setSlots = PayloadAction<{ value: TimeSlotsModel[]; id: string }>
	export type createAppointment = PayloadAction<{
		order_id: number
		data: AppointmentDataModel
		callback?: Callback
	}>
	export type setAppointment = PayloadAction<{ value: string; id: number }>

	export type getAddress = PayloadAction<AddressParamsModel>
	export type setAddress = PayloadAction<ResponseCatalog<AddressModel>>
	export type setAddressParams = PayloadAction<RequestParams>

	export type getPaperlessStatus = PayloadAction<{
		params?: RequestParams
	}>
	export type setPaperlessStatus = PayloadAction<{ value: string; id: string }>
	export type SetFormError = PayloadAction<number>
	export type ClearFormError = PayloadAction
	export type setAppointmentTimer = PayloadAction<number>
	export type sentAppointmentRequest = PayloadAction<boolean>
	export type setOutOfficeReserveError = PayloadAction<string>
}

export const outOfficeSlice = createSlice({
	name: 'outOfficeManager',
	initialState: outOfficeInitialState,
	reducers: {
		getCitiesRegions: (state, action: outOfficeNS.getCitiesRegions) => {},
		setCitiesRegions: (state, action: outOfficeNS.setCitiesRegions) => {
			state.items = action.payload
		},
		setRequestParams: (state, action: outOfficeNS.setRequestParams) => {
			state.params = action.payload
		},
		clearCitiesRegions: (state) => {
			state.items = []
			state.params = new RequestParams()
		},

		getSlots: (state, action: outOfficeNS.getSlots) => {},
		setSlots: (state, action: outOfficeNS.setSlots) => {
			const { value, id } = action.payload
			const nextState = { ...state, slots: new Map(state.slots) }
			nextState.slots.set(id, value)
			return nextState
		},
		clearSlots: (state) => {
			state.slots = new Map()
		},

		createAppointment: (state, action: outOfficeNS.createAppointment) => {},
		setAppointment: (state, action: outOfficeNS.setAppointment) => {
			state.appointment_response = action.payload
		},

		clearAppointment: (state) => {
			state.appointment_response = { value: null, id: null }
		},

		getAddress: (state, action: outOfficeNS.getAddress) => {},
		setAddress: (state, action: outOfficeNS.setAddress) => {
			const nextState = { ...state }
			// @ts-ignore
			action.payload.entries = action.payload.entries.map((item) => {
				const add = { key: `${item.geo_lat},${item.geo_lon}`, value: item.result }
				return add
			})
			nextState.address = action.payload
			return nextState
		},
		setAddressParams: (state, action: outOfficeNS.setAddressParams) => {
			state.addressParams = action.payload
		},
		clearAddress: (state) => {
			state.address = new ResponseCatalog<AddressModel>()
		},

		getPaperlessStatus: (state, action: outOfficeNS.getPaperlessStatus) => {},
		setPaperlessStatus: (state, action: outOfficeNS.setPaperlessStatus) => {
			state.appointment_status = action.payload
		},
		clearPaperlessStatus: (state) => {
			state.appointment_status = { value: null, id: null }
		},
		setFormError: (state, action: outOfficeNS.SetFormError) => {
			state.formError = action.payload
		},
		clearFormError: (state, action: outOfficeNS.ClearFormError) => {
			state.formError = null
		},
		setAppointmentTimer: (state, action: outOfficeNS.setAppointmentTimer) => {
			state.appointment_timer = action.payload
		},
		sentAppointmentRequest: (state, action: outOfficeNS.sentAppointmentRequest) => {
			state.sentAppointmentRequest = action.payload
		},
		setOutOfficeReserveError: (state, action: outOfficeNS.setOutOfficeReserveError) => {
			state.outOfficeReserveError = action.payload
		},
	},
})
